export * from './ClearActivityStyleProperty';
